import React = require('react');
import { useEffect } from 'react';
import { Field, formValueSelector } from 'redux-form';
import FieldFormControl from '../../../../../../components/FieldFormControl';
import { connect } from 'react-redux';

const MarketingOptions = ({ marketing, change }) => {
  useEffect(() => {
    change('marketing.accepted', true);
    change('marketing.options.email', true);
    change('marketing.options.sms', true);
    change('marketing.options.post', true);
    change('marketing.options.phone', true);
  }, [])
  const renderOption = (option) => {
    return (
      <div className={'option-new'}>
        <div className="checkbox-button-square">
          <Field
            name={option.name}
            type="checkbox"
            component={FieldFormControl}
          >
            <div/>
          </Field>
        </div>
        <div className="checkbox-text">
          <div>{ option.title }</div>
        </div>
      </div>
    )
  }

  const options = [
    {name: 'marketing.options.email', title: 'Email'},
    {name: 'marketing.options.sms', title: 'SMS'},
    {name: 'marketing.options.post', title: 'Post'},
    {name: 'marketing.options.phone', title: 'Phone'},
  ];

  return (
    <div className={'section-group'}>
      <div className="quote-card-title" style={{ marginBottom: 0 }}>
        Marketing Preference
      </div>
      <div>
        <div>
          <div className={'checkbox-group'}>
            <div className={'option-new'}  style={{ width: '100%' }}>
              <div className="checkbox-button-square">
                <Field
                  name={'marketing.accepted'}
                  type="checkbox"
                  component={FieldFormControl}
                >
                  <div/>
                </Field>
              </div>
              <div className="checkbox-text">
                <div>I want to hear about Admiral Insurance's latest discounts, offers and updates.</div>
              </div>
            </div>
          </div>

          {marketing?.accepted && <>
            <div style={{ padding: '5px' }}>Preferred way to be contacted:</div>
            <div className={'checkbox-group quote-marketing-checkbox-group margin-top'}>
              {options.map((option, index) =>
                renderOption(option)
              )}
            </div>
          </>
          }
        </div>
      </div>
    </div>
  )
}

const makeMapStateToProps = (initialState, ownProps) => {
  const selector = formValueSelector(ownProps.formName);

  return (state) => ({
    marketing: selector(state, 'marketing'),
  });
};

export default connect(makeMapStateToProps)(MarketingOptions);
